import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiPanel {
    constructor() {

    }

    createPanel() {
    }

    setPanelColor() {
    }

    setPanelImage() {
    }
}
